<template>
  <v-dialog
    v-model="visible"
    @keydown.esc="close"
    persistent
    scrollable
    style="z-index: 6"
    max-width="50%"
    min-width="50%"
  >
    <v-form ref="menuForm" @submit.prevent="submit">
      <v-card
        height="100vh"
        class="overflow-auto pb-5"
        :class="{ 'mobile-card': $vuetify.breakpoint.smAndDown }"
      >
        <v-card-title class="d-flex" style="vertical-align: middle">
          <v-row class="pa-3 mb-2">
            <h2 class="text--secondary">Meni</h2>
            <v-spacer></v-spacer>
            <v-icon large @click="close">mdi-close</v-icon>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row style="padding: 0 !important; margin: 0 !important">
              <v-col
                cols="4"
                class="d-flex justify-start"
                style="height: 44px !important"
              >
                <v-text-field
                  outlined
                  dense
                  label="Ime menija"
                  height="44px"
                  v-if="menu !== undefined && menu.name !== undefined"
                  v-model="menu.name"
                ></v-text-field>
              </v-col>
              <v-col cols="5">
                <v-combobox
                  outlined
                  autocomplete="off"
                  v-model="selectedPrices"
                  height="44px"
                  :items="[]"
                  dense
                  label="Cijene za artikla u valutama"
                  multiple
                  chips
                  clearable
                  @click="openAddPriceForm"
                  @keydown.enter="openAddPriceForm"
                  @keydown="preventTextInput($event)"
                  :rules="[rules.arrReq]"
                >
                  <template v-slot:selection="{ item }">
                    <v-chip
                      class="mt-1 mr-0"
                      close
                      @click="editPrice(item)"
                      @click:close="removePrice(item)"
                    >
                      <div v-if="manualPriceInput">
                        {{ item.currency }}
                      </div>
                      <div v-else>
                        {{ item.price | money(0, item.currency) }}
                      </div>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
              <v-col class="d-flex justify-end">
                <v-checkbox
                  class="pa-0 ma-0 pt-2"
                  v-model="manualPriceInput"
                  label="Bez unosa cijene"
                >
                </v-checkbox>
              </v-col>
            </v-row>

            <v-expansion-panels flat>
              <v-expansion-panel
                style="
                  border: 1px solid #e4e4e4;
                  border-radius: 5px 5px 0 0;
                  margin-bottom: -1px;
                "
              >
                <v-expansion-panel-header>
                  <v-row>
                    <v-col class="d-flex justify-center">
                      <p class="text-h6 font-weight-bold mb-0">Stavke</p>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    ref="dt_table"
                    :headers="productHeaders"
                    :items="productTableRows"
                    :single-expand="true"
                    :expanded.sync="expandedProducts"
                    item-key="name"
                    show-expand
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>Popis stavki</v-toolbar-title>
                        <v-btn
                          class="mx-2 white--text okButton"
                          style="
                            border-color: #e4e4e4;
                            margin-top: 0.2rem;
                            height: 1.6rem;
                          "
                          outlined
                          small
                          @click="openAddProductToMenuForm()"
                          >Dodaj stavku</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-toolbar>
                    </template>
                    <template v-slot:item="{ item, expand, isExpanded }">
                      <tr>
                        <td>{{ item.name }}</td>
                        <td>{{ findType(item.type) }}</td>
                        <td>
                          <v-btn icon @click="openAddProductToMenuForm(item)">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </td>
                        <td>
                          <v-btn icon @click="removeProductFromMenu(item)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </td>
                        <td>
                          <v-btn icon @click="expand(!isExpanded)">
                            <v-icon>{{
                              isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
                            }}</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:expanded-item="{ item }">
                      <tr>
                        <td>Ime artikla</td>
                        <td>Šifra artikla</td>
                        <td>Zadani artikl</td>
                      </tr>
                      <tr
                        v-for="(it, index) in item.product_items"
                        :key="item.id + it.company_item.id + index"
                      >
                        <td>{{ it.company_item.name }}</td>
                        <td>{{ it.company_item.code }}</td>
                        <td>{{ it.default ? "Da" : "Ne" }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                style="
                  border: 1px solid #e4e4e4;
                  border-radius: 0;
                  margin-bottom: -1px;
                "
              >
                <v-expansion-panel-header>
                  <v-row>
                    <v-col class="d-flex justify-center">
                      <p class="text-h6 font-weight-bold mb-0">
                        Opcije bez plaćanja
                      </p>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    :headers="tagHeaders"
                    :items="tagTableRows"
                    :single-expand="true"
                    :expanded.sync="expandedTags"
                    item-key="name"
                    show-expand
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title
                          >Popis opcija bez plaćanja</v-toolbar-title
                        >
                        <v-btn
                          class="mx-2 white--text okButton"
                          style="
                            border-color: #e4e4e4;
                            margin-top: 0.2rem;
                            height: 1.6rem;
                          "
                          outlined
                          small
                          @click="openAddTagToMenuForm()"
                          >Dodaj opciju bez plaćanja</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-toolbar>
                    </template>
                    <template v-slot:item="{ item, expand, isExpanded }">
                      <tr>
                        <td>{{ item.name }}</td>
                        <td>{{ findType(item.type) }}</td>
                        <td>
                          <v-btn icon @click="openAddTagToMenuForm(item)">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </td>
                        <td>
                          <v-btn icon @click="removeTagFromMenu(item)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </td>
                        <td>
                          <v-btn icon @click="expand(!isExpanded)">
                            <v-icon>{{
                              isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
                            }}</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:expanded-item="{ item }">
                      <tr>
                        <td>Tekst taga</td>
                        <td>Zadani artikl</td>
                      </tr>
                      <tr
                        v-for="(it, index) in item.tag_texts"
                        :key="it.id + index"
                      >
                        <td>{{ it.text }}</td>
                        <td>{{ it.default ? "Da" : "Ne" }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                style="border: 1px solid #e4e4e4; border-radius: 0 0 5px 5px"
              >
                <v-expansion-panel-header>
                  <v-row>
                    <v-col class="d-flex justify-center">
                      <p class="text-h6 font-weight-bold mb-0">
                        Opcije s plaćanjem
                      </p>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    ref="dt_table"
                    :headers="optionHeaders"
                    :items="optionTableRows"
                    :single-expand="true"
                    :expanded.sync="expandedOptions"
                    item-key="name"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>Popis opcija</v-toolbar-title>
                        <v-btn
                          class="mx-2 white--text okButton"
                          style="
                            border-color: #e4e4e4;
                            margin-top: 0.2rem;
                            height: 1.6rem;
                          "
                          outlined
                          small
                          @click="openAddOptionToMenuForm()"
                          >Dodaj plaćenu opciju</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-toolbar>
                    </template>
                    <template v-slot:item="{ item, expand, isExpanded }">
                      <tr>
                        <td>{{ item.name }}</td>
                        <td>{{ findType(item.type) }}</td>
                        <td>
                          <v-btn icon @click="openAddOptionToMenuForm(item)">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </td>
                        <td>
                          <v-btn icon @click="removeOptionFromMenu(item)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </td>
                        <td>
                          <v-btn icon @click="expand(!isExpanded)">
                            <v-icon>{{
                              isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
                            }}</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:expanded-item="{ item }">
                      <tr>
                        <td>Ime artikla</td>
                        <td>Šifra artikla</td>
                        <td>Zadani artikl</td>
                        <td>Cijena</td>
                      </tr>
                      <tr
                        v-for="(it, index) in item.option_items"
                        :key="item.id + it.company_item.id + index"
                      >
                        <td>{{ it.company_item.name }}</td>
                        <td>{{ it.company_item.code }}</td>
                        <td>{{ it.default ? "Da" : "Ne" }}</td>
                        <td>
                          <v-chip
                            v-for="(price, k) in it.prices"
                            :key="price.price + k"
                            class="mt-1 mr-0"
                          >
                            <div v-if="manualPriceInput">
                              {{ price.currency }}
                            </div>
                            <div v-else>
                              {{ price.price | money(100, price.currency) }}
                            </div>
                          </v-chip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            class="white--text okButton"
            height="45"
            :loading="submitting"
            :disabled="submitting"
            type="submit"
            id="lastElement"
          >
            Spremi artikl
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <add-price
      ref="addPrice"
      :taxes="taxes"
      :isManual="manualPriceInput"
      @add="onAddPrice"
    ></add-price>
    <add-product-to-menu
      ref="addProductToMenu"
      @add="onAddProductToMenu"
    ></add-product-to-menu>
    <add-tag-to-menu ref="addTagToMenu" @add="onAddTagToMenu"></add-tag-to-menu>
    <add-option-to-menu
      ref="addOptionToMenu"
      @add="onAddOptionToMenu"
    ></add-option-to-menu>
  </v-dialog>
</template>
<script>
import state from '@/state'
import { auth, df, functions } from '@/plugins/firebase'
import rules from '@/plugins/rules'
import { v4 as uuidv4 } from 'uuid'
import { clone } from '@/plugins/utils'
import AddPrice from '@/modules/point-of-sale/components/AddPrice'
import AddProductToMenu from '@/modules/point-of-sale/components/menu-item/AddProductToMenu'
import AddTagToMenu from '@/modules/point-of-sale/components/menu-item/AddTagToMenu'
import AddOptionToMenu from '@/modules/point-of-sale/components/menu-item/AddOptionToMenu'
export default {
  components: { AddPrice, AddProductToMenu, AddTagToMenu, AddOptionToMenu },
  inject: ['showMsgBox', 'showLoader', 'hideLoader', 'showAlert'],
  data: () => ({
    visible: false,
    menuName: '',
    expandedProducts: [],
    expandedTags: [],
    expandedOptions: [],
    submitting: false,
    loading: false,
    manualPriceInput: false,
    selectedPrices: [],
    previousPrices: [],
    taxes: [],
    showProducts: false,
    showTags: false,
    showOptions: false,
    rules: {
      req: rules.req(),
      arrReq: rules.arrReq(),
      money: rules.money()
    },
    listeners: [],
    productHeaders: [
      {
        text: 'Ime stavke',
        value: 'productName',
        align: 'start'
      },
      {
        text: 'Tip stavke',
        value: 'productType'
      },
      {
        text: 'Uredi',
        value: ''
      },
      {
        text: 'Ukloni',
        value: ''
      },
      { text: '', value: 'data-table-expand' }
    ],
    productTableRows: [],
    tagHeaders: [
      {
        text: 'Ime stavke',
        value: 'tagName',
        align: 'start'
      },
      {
        text: 'Tip stavke',
        value: 'tagType'
      },
      {
        text: 'Uredi',
        value: ''
      },
      {
        text: 'Ukloni',
        value: ''
      },
      { text: '', value: 'data-table-expand' }
    ],
    tagTableRows: [],
    optionHeaders: [
      {
        text: 'Ime stavke',
        value: 'optionName',
        align: 'start'
      },
      {
        text: 'Tip stavke',
        value: 'optionType'
      },
      {
        text: 'Uredi',
        value: ''
      },
      {
        text: 'Ukloni',
        value: ''
      },
      { text: '', value: 'data-table-expand' }
    ],
    optionTableRows: [],
    selectedLocations: [],
    locations: [],
    multiplier: undefined,
    menu: undefined
  }),
  async mounted () {
    this.getMultiplier()
  },
  beforeDestroy () {
    if (this.listeners) {
      this.detachListeners()
    }
  },
  methods: {
    findType (type) {
      switch (type) {
        case 'manC':
          return 'Višestruki odabir - obavezan'
        case 'optC':
          return 'Višestruki odabir - opcionalan'
        case 'manR':
          return 'Jednostruki odabir - obavezan'
        case 'optR':
          return 'Jednostruki odabir - opcionalan'
      }
    },
    preventTextInput (e) {
      if (e.keyCode !== 9 && e.keyCode !== 27) {
        this.openAddPriceForm()
        e.preventDefault()
      }
    },
    removeTagFromMenu (item) {
      const tmp = []
      this.menu.tags.forEach(tag => {
        if (tag.id !== item.id) {
          tmp.push(tag)
        }
      })

      this.menu.tags = tmp

      this.tagTableRows = this.menu.tags
      if (this.menu.tags === undefined || this.menu.tags.length === 0) {
        this.tagTableRows = []
        this.showTags = false
      }
      this.$forceUpdate()
    },
    removeProductFromMenu (item) {
      const tmp = []
      this.menu.products.forEach(product => {
        if (product.id !== item.id) {
          tmp.push(product)
        }
      })

      this.menu.products = tmp

      this.productTableRows = this.menu.products
      if (this.menu.products === undefined || this.menu.products.length === 0) {
        this.productTableRows = []
        this.showProducts = false
      }
      this.$forceUpdate()
    },
    removeOptionFromMenu (item) {
      const tmp = []
      this.menu.options.forEach(option => {
        if (option.id !== item.id) {
          tmp.push(option)
        }
      })

      this.menu.options = tmp

      this.optionTableRows = this.menu.options
      if (this.menu.options === undefined || this.menu.options.length === 0) {
        this.optionTableRows = []
        this.showOptions = false
      }
      this.$forceUpdate()
    },
    onAddProductToMenu (productItem, existing) {
      if (!existing) {
        if (this.menu.products === undefined) {
          this.menu.products = []
        }
        this.menu.products.push(productItem)
      } else {
        this.menu.products.forEach((product, key) => {
          if (product.id === productItem.id) {
            this.menu.products[key] = productItem
          }
        })
      }

      this.showProducts = true
      this.productTableRows = []
      this.productTableRows = this.menu.products

      this.productTableRows = JSON.parse(JSON.stringify(this.menu.products))

      this.$forceUpdate()
    },
    onAddTagToMenu (tagItem, existing) {
      if (!existing) {
        if (this.tagTableRows === undefined) {
          this.tagTableRows = []
        }
        this.tagTableRows.push(tagItem)
      } else {
        this.tagTableRows.forEach((tag, key) => {
          if (tag.id === tagItem.id) {
            this.tagTableRows[key] = tagItem
          }
        })
      }

      this.showTags = true
      this.menu.tags = this.tagTableRows
      this.tagTableRows = this.menu.tags
      this.tagTableRows = JSON.parse(JSON.stringify(this.menu.tags))
      this.$forceUpdate()
    },
    onAddOptionToMenu (optionItem, existing) {
      if (!existing) {
        if (this.menu.options === undefined) {
          this.menu.options = []
        }

        //   Object.keys(this.item.prices).forEach((key) => {
        // const item = this.item.prices[key]
        // item.price = (item.price / 100).toFixed(2)
        // item.taxes = item.taxes.map((tax) => {
        //   return {
        //     name: tax.name,
        //     rate: tax.rate ? tax.rate : 0
        //   }
        // })
        // this.selectedPrices.push(item)

        this.menu.options.push(optionItem)
      } else {
        this.menu.options.forEach((option, key) => {
          if (option.id === optionItem.id) {
            this.menu.options[key] = optionItem
          }
        })
      }

      this.showOptions = true
      this.optionTableRows = []
      this.optionTableRows = this.menu.options

      this.optionTableRows = JSON.parse(JSON.stringify(this.menu.options))
      this.$forceUpdate()
    },
    getMultiplier () {
      const listener = df.doc('project_constants/config').onSnapshot(doc => {
        this.config = doc.data()
        this.paymentModels = doc.data().payment_models
        this.multiplier = doc.data().item_amount.decimal_multiplier
      })
      this.listeners.push(listener)
    },

    open (menu) {
      this.visible = true
      this.listeners.push(
        df.doc('project_constants/taxes').onSnapshot((doc) => {
          if (doc.data() && doc.data().pdv && doc.data().pdv.length > 0) {
            this.taxes = doc.data().pdv.map((tax) => {
              return {
                ...tax,
                ...{
                  disabled:
                    !state.getCurrentCompany().is_taxed && tax.rate !== 0
                }
              }
            })
          }
        })
      )

      this.listeners.push(
        df
          .doc(
            `user_locations/${auth.currentUser.uid}.${
              state.getCurrentCompany().id
            }`
          )
          .onSnapshot((doc) => {
            if (
              doc.data() &&
              doc.data().locations &&
              Object.keys(doc.data().locations).length > 0
            ) {
              this.locations = Object.keys(doc.data().locations)
                .map((key) => {
                  return doc.data().locations[key]
                })
                .filter((location) => location.status === 'OK')

              this.selectedLocations = this.locations.map((location) => {
                return location.id
              })
            }
          })
      )

      this.menu = clone(menu)
      this.selectedPrices = []
      Object.keys(this.menu.prices).forEach((key) => {
        const item = this.menu.prices[key]
        item.price = (item.price / 100).toFixed(2)
        item.taxes = item.taxes.map((tax) => {
          return {
            name: tax.name,
            rate: tax.rate ? tax.rate : 0
          }
        })
        this.selectedPrices.push(item)
      })

      if (this.menu.products !== undefined && this.menu.products !== null && this.menu.products.length > 0) {
        this.productTableRows = this.menu.products.sort((a, b) => a.name.localeCompare(b.name))
        this.showProducts = true
      }

      if (this.menu.tags !== undefined && this.menu.tags !== null && this.menu.tags.length > 0) {
        this.tagTableRows = this.menu.tags.sort((a, b) => a.name.localeCompare(b.name))
        this.showTags = true
      }

      if (this.menu.options !== undefined && this.menu.options !== null && this.menu.options.length > 0) {
        this.menu.options.forEach((option, i) => {
          option.option_items.forEach((item, j) => {
            var pr = []
            Object.keys(item.prices).forEach((key) => {
              const it = item.prices[key]
              it.currency = key
              it.taxes = it.taxes.map((tax) => {
                return {
                  name: tax.name,
                  rate: tax.rate ? tax.rate : 0
                }
              })

              pr.push(it)
            })

            this.menu.options[i].option_items[j].prices = pr
          })
        })
        this.optionTableRows = this.menu.options.sort((a, b) => a.name.localeCompare(b.name))
        this.showOptions = true
      }
    },
    close () {
      this.detachListeners()
      this.$nextTick(() => {
        this.visible = false
      })
    },
    openAddProductToMenuForm (productItem = undefined) {
      if (productItem !== undefined) {
        this.menu.products.forEach(product => {
          if (product.id === productItem.id) {
            this.$refs.addProductToMenu.open(product, true, this.selectedLocations, this.locations)
          }
        })
      } else {
        this.$refs.addProductToMenu.open(undefined, true, this.selectedLocations, this.locations)
      }
    },
    openAddTagToMenuForm (existingTag = undefined) {
      // console.log(existingTag)
      if (existingTag !== undefined) {
        this.tagTableRows.forEach(tag => {
          if (tag.id === existingTag.id) {
            this.$refs.addTagToMenu.open(existingTag, true)
          }
        })
      } else {
        this.$refs.addTagToMenu.open(undefined, true)
      }
    },
    openAddOptionToMenuForm (optionItem = undefined) {
      if (optionItem !== undefined) {
        this.menu.options.forEach(option => {
          if (option.id === optionItem.id) {
            this.$refs.addOptionToMenu.open(option, true)
          }
        })
      } else {
        this.$refs.addOptionToMenu.open(undefined, true)
      }
    },
    openAddPriceForm () {
      this.$refs.addPrice.open()
    },
    onAddPrice (priceItem) {
      if (
        this.selectedPrices.some((item) => item.currency === priceItem.currency)
      ) {
        const sameItem = this.selectedPrices.find(
          (it) => it.currency === priceItem.currency
        )
        this.selectedPrices = this.selectedPrices.map((item) => {
          item.price = item === sameItem ? priceItem.price : item.price
          return item
        })
      } else {
        this.selectedPrices.push(priceItem)
      }
    },
    removePrice (priceItem) {
      this.selectedPrices = this.selectedPrices.filter(
        (item) => item !== priceItem
      )
    },
    editPrice (priceItem) {
      this.$refs.addPrice.open(priceItem)
    },
    detachListeners () {
      this.listeners.forEach((listener) => {
        listener()
        this.listeners = this.listeners.filter((l) => l !== listener)
      })
    },
    submit () {
      this.submitting = true

      const realProducts = []
      const realTags = []
      const realOptions = []

      this.menu.products.forEach((product, key) => {
        const productItems = []
        realProducts.push({
          id: product.id,
          name: product.name,
          type: product.type
        })

        product.product_items.forEach(item => {
          productItems.push({
            company_item: item.company_item,
            default: item.default
          })
        })

        realProducts[key].product_items = productItems
      })

      this.menu.tags.forEach((tag, key) => {
        const tagTexts = []

        realTags.push({
          id: tag.id,
          name: tag.name,
          type: tag.type
        })

        tag.tag_texts.forEach(tagText => {
          tagTexts.push({
            id: tagText.id,
            text: tagText.text,
            default: tagText.default
          })
        })

        realTags[key].tag_texts = tagTexts
      })

      this.menu.options.forEach((option, key) => {
        const optionItems = []
        realOptions.push({
          id: option.id,
          name: option.name,
          type: option.type
        })

        option.option_items.forEach(item => {
          const pr = item.prices.reduce((prices, it) => {
            return Object.assign(prices, {
              [it.currency]: {
                active: true,
                price: it.price,
                taxes: it.taxes.map((tax) => {
                  return { name: tax.name, rate: tax.rate }
                })
              }
            })
          }, {})

          delete item.prices

          optionItems.push({
            company_item: item.company_item,
            default: item.default,
            prices: pr
          })
        })

        realOptions[key].option_items = optionItems
      })

      let prices = {}
      if (this.manualPriceInput) {
        prices = this.selectedPrices.reduce((prices, it) => {
          return Object.assign(prices, {
            [it.currency]: {
              active: true,
              price: 0,
              taxes: it.taxes.map((tax) => {
                return { name: tax.name, rate: tax.rate }
              })
            }
          })
        }, {})
      } else {
        prices = this.selectedPrices.reduce((prices, it) => {
          return Object.assign(prices, {
            [it.currency]: {
              active: true,
              price: it.price * 100,
              taxes: it.taxes.map((tax) => {
                return { name: tax.name, rate: tax.rate }
              })
            }
          })
        }, {})
      }

      let manualPrice = false
      if (this.manualPriceInput !== undefined) {
        manualPrice = this.manualPriceInput
      }

      const categories = []
      categories.push({
        id: uuidv4(),
        name: 'menu item'
      })

      const payload = {
        action: {
          operation: 'set',
          entity: 'menu_item',
          params: {
            menu_item: {
              id: this.menu.id,
              name: this.menu.name,
              products: realProducts,
              tags: realTags,
              options: realOptions
            },
            company_id: state.getCurrentCompany().id,
            locations: this.selectedLocations,
            pricing_info: {
              active: true,
              categories: categories,
              prices: prices,
              manual_price_input: manualPrice
            }

          }
        }
      }

      try {
        var companyitemApi = functions.httpsCallable('companyitemapi')

        companyitemApi({
          action: {
            operation: payload.action.operation,
            entity: payload.action.entity,
            resource_id: payload.action.resource_id,
            params: payload.action.params
          }
        })
          .then((result) => {
            if (result.data.code === 200) {
              this.$emit('refresh')
              this.$refs.menuForm.reset()
              this.submitting = false
              this.visible = false
            } else {
              this.showMsgBox({
                text: result.data.message ?? 'Dogodila se pogreška.',
                actions: ['cancel'],
                cancelBtnText: 'OK',
                color: 'error'
              })
              this.submitting = false
            }
          })
      } catch (err) {
        this.showMsgBox({
          text: err && err !== '' ? err : 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
        this.submitting = false
      }
    }
  }
}
</script>
<style>
.items {
  max-height: 300px;
  height: 300px;
  overflow-y: auto;
}

.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
</style>
